module.exports = __webpack_public_path__ + "static/media/3.f1663889.png";